import { createInterfaceId } from "@gitlab/needle";
//#region src/rpc_message_sender.ts
const RpcMessageSender = createInterfaceId("RpcMessageSender");
//#endregion
//#region src/errors/rpc_validation_error.ts
var RpcValidationError = class extends Error {
	constructor(message, details) {
		super(message);
		this.name = "RpcValidationError";
		this.details = details;
	}
};
var RpcParamsValidationError = class extends RpcValidationError {
	constructor(methodName, details) {
		super(`Parameter validation failed for ${methodName}`, details);
		this.name = "RpcParamsValidationError";
	}
};
var RpcResponseValidationError = class extends RpcValidationError {
	constructor(methodName, details) {
		super(`Response validation failed for ${methodName}`, details);
		this.name = "RpcResponseValidationError";
	}
};
//#endregion
//#region src/default_rpc_message_sender.ts
var DefaultRpcMessageSender = class {
	#connection;
	#messageDefinitions;
	constructor(connection, messageDefinitions) {
		this.#connection = connection;
		this.#messageDefinitions = messageDefinitions;
	}
	send = async (message, params) => {
		if (!this.#messageDefinitions.getMessageDefinitions().includes(message)) throw new Error(`Unknown message ${message.methodName}.`);
		if (message.paramsSchema && params !== void 0) this.#validate(message.paramsSchema, params, message.methodName, (m, d) => new RpcParamsValidationError(m, d));
		if (message.type === "notification") {
			await this.#connection.sendNotification(message.methodName, params);
			return;
		}
		if (message.type === "request") {
			const result = await this.#connection.sendRequest(message.methodName, params);
			return this.#validate(message.responseSchema, result, message.methodName, (m, d) => new RpcResponseValidationError(m, d));
		}
		throw new Error(`Unknown message type`);
	};
	#validate(schema, value, methodName, errorFactory) {
		const result = schema.safeParse(value);
		if (!result.success) throw errorFactory(methodName, result.error.message);
		return result.data;
	}
};
//#endregion
export { DefaultRpcMessageSender, RpcMessageSender };

//# sourceMappingURL=index.mjs.map